@if (!onFullChatPage()) {
  <button
    type="button"
    class="chat-buddy-launcher"
    [class.open]="open()"
    [attr.aria-expanded]="open()"
    aria-label="Open AI assistant"
    title="AI assistant"
    (click)="toggleDrawer()"
  >
    <img src="assets/icons/chat_buddy.svg" alt="" class="chat-buddy-launcher-icon" />
    @if (hasUnread()) {
      <span class="chat-buddy-launcher-badge" aria-hidden="true"></span>
    }
  </button>
}

<aio-drawer
  [open]="open()"
  position="end"
  [showClose]="false"
  panelClass="chat-buddy-drawer"
  width="560px"
  (closed)="closeDrawer()"
>
  <div aio-drawer-header>
    <div class="chat-buddy-header">
      <div class="chat-buddy-header-text">
        <span class="chat-buddy-title">AI Assistant</span>
        <span class="chat-buddy-conn" [class.ok]="signalr.connected()">
          {{ signalr.connected() ? 'Connected' : 'Offline' }}
        </span>
      </div>

      <div class="chat-buddy-header-actions">
        <button
          type="button"
          class="chat-buddy-icon-button"
          aria-label="New chat"
          title="New chat"
          (click)="newChat()"
        >
          <img src="assets/icons/add.svg" alt="" class="chat-buddy-icon" />
        </button>
        @if (fullChatLink()) {
          <button
            type="button"
            class="chat-buddy-icon-button"
            aria-label="Open full AI Chat"
            title="Open full AI Chat"
            (click)="openFullChat()"
          >
            <img src="assets/icons/launch.svg" alt="" class="chat-buddy-icon" />
          </button>
        }
        <button
          type="button"
          class="chat-buddy-icon-button"
          aria-label="Close"
          title="Close"
          (click)="closeDrawer()"
        >
          <img src="assets/icons/close.svg" alt="" class="chat-buddy-icon" />
        </button>
      </div>
    </div>
  </div>

    <div class="chat-buddy-thread" #threadEl>
      @if (messages().length === 0) {
        <aio-empty-state
          class="chat-buddy-zero-state"
          title="How can I help?"
          message="Ask about your projects, costs, schedule, and documents. Open the full AI Chat for history and artifacts."
          iconSrc="assets/icons/chat_buddy.svg"
        />
      } @else {
        <app-agent-message-list
          [messages]="messages()"
          [status]="activeStatus()"
          [showToolDetails]="showToolDetails"
          [downloadingArtifactId]="downloadingArtifactId()"
          (downloadArtifact)="downloadArtifact($event)"
        />
      }
    </div>

  <div aio-drawer-footer>
    <div class="chat-buddy-footer">
      @if (runError()) {
        <div class="chat-buddy-run-error" role="alert">
          <strong>Agent stopped</strong>
          <span>{{ runError() }}</span>
        </div>
      }

      @if (activeLeaf(); as leaf) {
        <app-agent-slot-filler
          [sessionTenantId]="sessionTenantId()"
          [serverId]="primaryServerId() ?? 0"
          [node]="leaf"
          (submit)="onSlotsSubmit($event)"
          (cancel)="closeSlotFiller()"
        />
      } @else if (currentSuggestions().length > 0 && !busy()) {
        <div class="chat-buddy-suggestions">
          <div class="sugg-head">
            <div class="sugg-head-left">
              @if (navParentId() !== null) {
                <button type="button" class="sugg-back" (click)="navBack()">‹ Back</button>
                <span class="sugg-crumb">{{ navBreadcrumb() }}</span>
              } @else {
                <span class="sugg-label">Suggested questions</span>
              }
            </div>
            <button
              type="button"
              class="sugg-toggle"
              (click)="toggleSuggestions()"
              [title]="suggestionsCollapsed() ? 'Show suggestions' : 'Hide suggestions'"
              [attr.aria-expanded]="!suggestionsCollapsed()"
            >
              {{ suggestionsCollapsed() ? '▸' : '▾' }}
            </button>
          </div>
          @if (!suggestionsCollapsed()) {
            <div class="sugg-chips">
              @for (node of currentSuggestions(); track node.id) {
                <button
                  type="button"
                  class="sugg-chip"
                  [class.leaf]="node.nodeType === 'leaf'"
                  (click)="pickNode(node)"
                >
                  {{ node.label }}
                  @if (node.nodeType !== 'leaf') {
                    <span class="sugg-arrow">›</span>
                  }
                </button>
              }
            </div>
          }
        </div>
      }

      <app-agent-message-composer [busy]="busy()" (send)="send($event)" (cancel)="cancel()" />
    </div>
  </div>
</aio-drawer>
